// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Shell metrics. Layout.jsx writes data-shell="phone|tablet|desktop" from
 * hooks/useViewport.js, so the CSS below and the JS that decides which nav to
 * render can never disagree about which layout a given width gets. (Before
 * this, ~10 overlapping 768-1366px media blocks fought an inline marginLeft
 * and left a transparent, tap-swallowing sidebar wrapper over the content.)
 *
 * --banner-h is the admin impersonation banner (0 when absent). Everything that
 * hangs off the top of the viewport adds it, so no per-width overrides exist.
 */
.layout-container {
  --navbar-h: 64px;
  --banner-h: 0px;
  min-height: 100vh;
  background-color: #f8f9fa;
}

/* viewport-fit=cover (index.html) lets the page use the whole screen in an
   installed/standalone app, so keep content clear of a landscape notch. These
   are 0 in a normal browser tab. */
.layout-container {
  padding-left: env(safe-area-inset-left, 0px);
  padding-right: env(safe-area-inset-right, 0px);
}

.layout-container .navbar.fixed-top {
  padding-left: env(safe-area-inset-left, 0px);
  padding-right: env(safe-area-inset-right, 0px);
}

.layout-container[data-shell="tablet"] {
  --navbar-h: 60px;
}

.layout-container[data-shell="phone"] {
  --navbar-h: 56px;
}

.navbar {
  height: var(--navbar-h, 64px);
  z-index: 1030;
}

/* Sit below the impersonation banner when it is showing. */
.layout-container .navbar.fixed-top {
  top: var(--banner-h, 0px);
}

.navbar + .d-flex {
  padding-top: calc(var(--navbar-h, 64px) + var(--banner-h, 0px));
}

/* Shrink-wraps the sidebar (72px rail / 160px expanded), so this box never
   covers more of the page than the sidebar itself. */
.sidebar-wrapper {
  position: fixed;
  top: calc(var(--navbar-h, 64px) + var(--banner-h, 0px));
  left: 0;
  bottom: 0;
  z-index: 1020;
}

/* Tablet: an expanded sidebar overlays the content; tapping outside closes it. */
.sidebar-scrim {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.28);
  z-index: 1019;
}

.sidebar {
  height: 100%;
  background-color: #ffffff;
  border-right: 1px solid #e9ecef;
  overflow-y: auto;
  overflow-x: hidden;
}

.content-area {
  min-height: calc(100vh - var(--navbar-h, 64px));
  padding: 16px;
  width: 100%;
  transition: margin-left 0.25s ease;
}

.layout-container[data-shell="phone"] .content-area {
  margin-left: 0 !important;
  padding: 12px;
}

.icon-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: rgba(220, 53, 69, 0.1);
}

.icon-wrapper.text-primary {
  background-color: rgba(13, 110, 253, 0.1);
}

/* Override Bootstrap styles */
.form-control {
  height: 40px;
  border-radius: 4px;
}

.form-control:focus {
  box-shadow: none;
  border-color: #dee2e6;
}

.form-select {
  height: 40px;
  border-radius: 4px;
}

.btn {
  height: 40px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-light {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.btn-primary {
  background-color: #c9194a;
  border: none;
}

.card {
  border-radius: 8px;
  border: none;
  box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1),
    0px 1px 2px rgba(16, 24, 40, 0.06);
}

/* Calendar View Styles */
.calendar-view {
  background-color: #ffffff;
}

.calendar-view .border-bottom {
  border-color: #e9ecef !important;
}

.calendar-view .position-absolute {
  transition: all 0.3s ease;
}

.calendar-view .position-absolute:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Appointment Form Styles */
.appointment-form .form-label {
  font-size: 14px;
  color: #212529;
  margin-bottom: 8px;
}

.appointment-form .form-control,
.appointment-form .form-select {
  height: 40px;
  font-size: 14px;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 8px 12px;
}

.appointment-form .form-control:disabled,
.appointment-form .form-select:disabled {
  background-color: #fff;
  border-color: #e9ecef;
  color: #212529;
  opacity: 1;
}

.appointment-form .text-muted {
  color: #6c757d !important;
  font-size: 14px;
}

.appointment-form .btn {
  height: 40px;
  font-size: 14px;
  padding: 8px 6px;
  border-radius: 4px;
}

/* Appointment Sidebar Popup Styles */
.appointment-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}

.appointment-sidebar-popup {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 423px;
  background-color: #ffffff;
  border-left: 1px solid #e9ecef;
  overflow-y: auto;
  z-index: 1050;
  padding: 24px;
  box-shadow: -4px 0 8px rgba(0, 0, 0, 0.1);
  animation: slideIn 0.3s ease;
}

.appointment-sidebar-popup h5 {
  font-size: 18px;
  font-weight: 500;
  color: #212529;
}

.appointment-sidebar-popup .btn-close {
  padding: 0;
  background: none;
  border: none;
  color: #6c757d;
  font-size: 20px;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

@media (max-width: 991.98px) {
  .appointment-sidebar-popup {
    width: 100%;
  }
}

@media (max-width: 575.98px) {
  .card-body {
    padding: 16px;
  }
}

/* Overview Section Styles */
.container-fluid h5 {
  font-size: 18px;
  font-weight: 600;
  color: #212529;
}

.btn.btn-light {
  font-size: 14px;
  padding: 8px 16px;
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  color: #495057;
  height: 40px;
}

.btn.btn-light:hover {
  background-color: #f8f9fa;
  border-color: #dee2e6;
}

.btn.btn-light svg {
  font-size: 16px;
  color: #495057;
}

.delete-confirmation-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px; /* ensure spacing on small screens */
  z-index: 9999;
  overflow: auto;
}

.delete-confirmation-popup {
  width: 100%;
  max-width: 90vw; /* or try 400px max on bigger screens */
  max-height: 90vh;
  overflow-y: auto;
  padding: 24px;
  border-radius: 16px;
  background-color: white;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
}
@media (min-width: 768px) {
  .delete-confirmation-popup {
    max-width: 500px;
  }
}

.delete-confirmation-popup h5 {
  font-size: 18px;
  font-weight: 500;
  color: #212529;
}

.delete-confirmation-popup p {
  font-size: 14px;
  margin-bottom: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Tablet: popups stay inside the viewport instead of the old 90%/80% overrides
   that were applied to every modal at 768-1366px (and defeated .modal-sm). */
.layout-container[data-shell="tablet"] .appointment-sidebar-popup {
  width: 80%;
  max-width: 500px;
}

/*
 * Touch devices (iPad, Android tablets, phones): finger-sized controls and no
 * focus-zoom. Keyed off the pointer, not the width, so a landscape iPad Pro and
 * a portrait iPad mini get the same treatment. Dense in-table controls opt out
 * with .btn-sm / .form-control-sm.
 *  - 44px is Apple's minimum comfortable tap target.
 *  - iOS Safari zooms the page on focus of any field under 16px.
 */
@media (pointer: coarse) {
  .btn:not(.btn-sm):not(.btn-small):not(.btn-close):not(.btn-link),
  .form-control:not(.form-control-sm),
  .form-select:not(.form-select-sm) {
    min-height: 44px;
  }

  input:not([type="checkbox"]):not([type="radio"]):not([type="range"]),
  select,
  textarea,
  .form-control,
  .form-select {
    font-size: 16px !important;
  }

  .sidebar-toggle {
    min-width: 44px;
    min-height: 44px;
  }

  /* react-datepicker days are ~27px by default. */
  .react-datepicker .react-datepicker__day,
  .react-datepicker .react-datepicker__day-name {
    width: 2.5rem;
    line-height: 2.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layout/Layout.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;AACF;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;mCAEmC;AACnC;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE,yBAAyB;AAC3B;;AAEA;EACE,+DAA+D;AACjE;;AAEA;qDACqD;AACrD;EACE,eAAe;EACf,uDAAuD;EACvD,OAAO;EACP,SAAS;EACT,aAAa;AACf;;AAEA,iFAAiF;AACjF;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,aAAa;EACb,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ;sCACoC;AACtC;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,oCAAoC;EACnD,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe,EAAE,uCAAuC;EACxD,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,sBAAsB;AACxB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;6EAC6E;AAC7E;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;;;;;EAOE;AACF;EACE;;;IAGE,gBAAgB;EAClB;;EAEA;;;;;IAKE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,gDAAgD;EAChD;;IAEE,aAAa;IACb,mBAAmB;EACrB;AACF","sourcesContent":["/*\n * Shell metrics. Layout.jsx writes data-shell=\"phone|tablet|desktop\" from\n * hooks/useViewport.js, so the CSS below and the JS that decides which nav to\n * render can never disagree about which layout a given width gets. (Before\n * this, ~10 overlapping 768-1366px media blocks fought an inline marginLeft\n * and left a transparent, tap-swallowing sidebar wrapper over the content.)\n *\n * --banner-h is the admin impersonation banner (0 when absent). Everything that\n * hangs off the top of the viewport adds it, so no per-width overrides exist.\n */\n.layout-container {\n  --navbar-h: 64px;\n  --banner-h: 0px;\n  min-height: 100vh;\n  background-color: #f8f9fa;\n}\n\n/* viewport-fit=cover (index.html) lets the page use the whole screen in an\n   installed/standalone app, so keep content clear of a landscape notch. These\n   are 0 in a normal browser tab. */\n.layout-container {\n  padding-left: env(safe-area-inset-left, 0px);\n  padding-right: env(safe-area-inset-right, 0px);\n}\n\n.layout-container .navbar.fixed-top {\n  padding-left: env(safe-area-inset-left, 0px);\n  padding-right: env(safe-area-inset-right, 0px);\n}\n\n.layout-container[data-shell=\"tablet\"] {\n  --navbar-h: 60px;\n}\n\n.layout-container[data-shell=\"phone\"] {\n  --navbar-h: 56px;\n}\n\n.navbar {\n  height: var(--navbar-h, 64px);\n  z-index: 1030;\n}\n\n/* Sit below the impersonation banner when it is showing. */\n.layout-container .navbar.fixed-top {\n  top: var(--banner-h, 0px);\n}\n\n.navbar + .d-flex {\n  padding-top: calc(var(--navbar-h, 64px) + var(--banner-h, 0px));\n}\n\n/* Shrink-wraps the sidebar (72px rail / 160px expanded), so this box never\n   covers more of the page than the sidebar itself. */\n.sidebar-wrapper {\n  position: fixed;\n  top: calc(var(--navbar-h, 64px) + var(--banner-h, 0px));\n  left: 0;\n  bottom: 0;\n  z-index: 1020;\n}\n\n/* Tablet: an expanded sidebar overlays the content; tapping outside closes it. */\n.sidebar-scrim {\n  position: fixed;\n  inset: 0;\n  background: rgba(17, 24, 39, 0.28);\n  z-index: 1019;\n}\n\n.sidebar {\n  height: 100%;\n  background-color: #ffffff;\n  border-right: 1px solid #e9ecef;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.content-area {\n  min-height: calc(100vh - var(--navbar-h, 64px));\n  padding: 16px;\n  width: 100%;\n  transition: margin-left 0.25s ease;\n}\n\n.layout-container[data-shell=\"phone\"] .content-area {\n  margin-left: 0 !important;\n  padding: 12px;\n}\n\n.icon-wrapper {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background-color: rgba(220, 53, 69, 0.1);\n}\n\n.icon-wrapper.text-primary {\n  background-color: rgba(13, 110, 253, 0.1);\n}\n\n/* Override Bootstrap styles */\n.form-control {\n  height: 40px;\n  border-radius: 4px;\n}\n\n.form-control:focus {\n  box-shadow: none;\n  border-color: #dee2e6;\n}\n\n.form-select {\n  height: 40px;\n  border-radius: 4px;\n}\n\n.btn {\n  height: 40px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.btn-light {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.btn-primary {\n  background-color: #c9194a;\n  border: none;\n}\n\n.card {\n  border-radius: 8px;\n  border: none;\n  box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1),\n    0px 1px 2px rgba(16, 24, 40, 0.06);\n}\n\n/* Calendar View Styles */\n.calendar-view {\n  background-color: #ffffff;\n}\n\n.calendar-view .border-bottom {\n  border-color: #e9ecef !important;\n}\n\n.calendar-view .position-absolute {\n  transition: all 0.3s ease;\n}\n\n.calendar-view .position-absolute:hover {\n  transform: scale(1.02);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* Appointment Form Styles */\n.appointment-form .form-label {\n  font-size: 14px;\n  color: #212529;\n  margin-bottom: 8px;\n}\n\n.appointment-form .form-control,\n.appointment-form .form-select {\n  height: 40px;\n  font-size: 14px;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  padding: 8px 12px;\n}\n\n.appointment-form .form-control:disabled,\n.appointment-form .form-select:disabled {\n  background-color: #fff;\n  border-color: #e9ecef;\n  color: #212529;\n  opacity: 1;\n}\n\n.appointment-form .text-muted {\n  color: #6c757d !important;\n  font-size: 14px;\n}\n\n.appointment-form .btn {\n  height: 40px;\n  font-size: 14px;\n  padding: 8px 6px;\n  border-radius: 4px;\n}\n\n/* Appointment Sidebar Popup Styles */\n.appointment-sidebar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1040;\n}\n\n.appointment-sidebar-popup {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 423px;\n  background-color: #ffffff;\n  border-left: 1px solid #e9ecef;\n  overflow-y: auto;\n  z-index: 1050;\n  padding: 24px;\n  box-shadow: -4px 0 8px rgba(0, 0, 0, 0.1);\n  animation: slideIn 0.3s ease;\n}\n\n.appointment-sidebar-popup h5 {\n  font-size: 18px;\n  font-weight: 500;\n  color: #212529;\n}\n\n.appointment-sidebar-popup .btn-close {\n  padding: 0;\n  background: none;\n  border: none;\n  color: #6c757d;\n  font-size: 20px;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n@media (max-width: 991.98px) {\n  .appointment-sidebar-popup {\n    width: 100%;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .card-body {\n    padding: 16px;\n  }\n}\n\n/* Overview Section Styles */\n.container-fluid h5 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #212529;\n}\n\n.btn.btn-light {\n  font-size: 14px;\n  padding: 8px 16px;\n  background-color: #ffffff;\n  border: 1px solid #e9ecef;\n  color: #495057;\n  height: 40px;\n}\n\n.btn.btn-light:hover {\n  background-color: #f8f9fa;\n  border-color: #dee2e6;\n}\n\n.btn.btn-light svg {\n  font-size: 16px;\n  color: #495057;\n}\n\n.delete-confirmation-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px; /* ensure spacing on small screens */\n  z-index: 9999;\n  overflow: auto;\n}\n\n.delete-confirmation-popup {\n  width: 100%;\n  max-width: 90vw; /* or try 400px max on bigger screens */\n  max-height: 90vh;\n  overflow-y: auto;\n  padding: 24px;\n  border-radius: 16px;\n  background-color: white;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n  box-sizing: border-box;\n}\n@media (min-width: 768px) {\n  .delete-confirmation-popup {\n    max-width: 500px;\n  }\n}\n\n.delete-confirmation-popup h5 {\n  font-size: 18px;\n  font-weight: 500;\n  color: #212529;\n}\n\n.delete-confirmation-popup p {\n  font-size: 14px;\n  margin-bottom: 0;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Tablet: popups stay inside the viewport instead of the old 90%/80% overrides\n   that were applied to every modal at 768-1366px (and defeated .modal-sm). */\n.layout-container[data-shell=\"tablet\"] .appointment-sidebar-popup {\n  width: 80%;\n  max-width: 500px;\n}\n\n/*\n * Touch devices (iPad, Android tablets, phones): finger-sized controls and no\n * focus-zoom. Keyed off the pointer, not the width, so a landscape iPad Pro and\n * a portrait iPad mini get the same treatment. Dense in-table controls opt out\n * with .btn-sm / .form-control-sm.\n *  - 44px is Apple's minimum comfortable tap target.\n *  - iOS Safari zooms the page on focus of any field under 16px.\n */\n@media (pointer: coarse) {\n  .btn:not(.btn-sm):not(.btn-small):not(.btn-close):not(.btn-link),\n  .form-control:not(.form-control-sm),\n  .form-select:not(.form-select-sm) {\n    min-height: 44px;\n  }\n\n  input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]),\n  select,\n  textarea,\n  .form-control,\n  .form-select {\n    font-size: 16px !important;\n  }\n\n  .sidebar-toggle {\n    min-width: 44px;\n    min-height: 44px;\n  }\n\n  /* react-datepicker days are ~27px by default. */\n  .react-datepicker .react-datepicker__day,\n  .react-datepicker .react-datepicker__day-name {\n    width: 2.5rem;\n    line-height: 2.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
